<template>
  <path
    d="M11.71 15.2902L14.3 12.7002C14.69 12.3102 14.69 11.6802 14.3 11.2902L11.71 8.70022C11.08 8.08022 10 8.52022 10 9.41022V14.5802C10 15.4802 11.08 15.9202 11.71 15.2902Z"
  />
</template>
